var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"path-1","points":"14.25 8.5 14.25 16.5 10 12.5397995","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
